// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { usePlatform } from '../../context/platform/hooks';
import { apiClient } from '../client';

export interface PatientConsentRequest {
  documentId: string;
  outcome: 'GRANTED' | 'DECLINED';
}

export interface PatientConsentResponse {
  outcome: string;
  redirectUrl: string | null;
}

export const usePatientConsentMutation = () => {
  const { codingContext } = usePlatform();
  return useMutation<PatientConsentResponse, Error, PatientConsentRequest>({
    mutationFn: async ({ documentId, outcome }) => {
      return apiClient.post<PatientConsentResponse>(
        'patientConsent',
        () => ({ documentId, outcome }),
        codingContext,
      );
    },
  });
};
